import { useReportTemplateContext } from "../ReportTemplate/ReportTemplateContext";

const GREEN = "#04aa00";
const LIGHT_GREY = "#f0f0f0";
const WHITE = "#ffffff";

export default function TulvariskiBlock() {
  const { rakennusData: kiinteisto } =
    useReportTemplateContext();

  const rakennukset =
    kiinteisto?.rakennukset_fulls ||
    kiinteisto?.rakennukset ||
    [];

  const getRakennusLabel = rakennus =>
    rakennus.rakennustunnus ||
    rakennus.Rakennustunnus ||
    rakennus.id_rakennus ||
    "Rakennus";

  const renderValue = value => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "–";
    }

    return String(value);
  };

  return (
    <div
      className="rounded border overflow-hidden"
      style={{
        backgroundColor: WHITE,
        borderColor: "#e9f0ec"
      }}
    >
      <section>
        <div
          className="px-3 py-2 fw-bold text-white"
          style={{ backgroundColor: GREEN }}
        >
          Tulvariskialueet
        </div>

        {rakennukset.length === 0 ? (
          <div className="p-3 text-muted">
            Ei tulvariskitietoja saatavilla.
          </div>
        ) : (
          rakennukset.map(
            (rakennus, rakennusIndex) => {
              const tulvariskialueet =
                rakennus.aluetiedot?.tulvariski ||
                [];

              // Kohde oikeasti polygonin sisällä
              const alueella =
                tulvariskialueet.filter(
                  item =>
                    item.etäisyys === "Alueella"
                );

              // Löytyi 500 m haussa, mutta kohde
              // ei sijaitse polygonin sisällä
              const lahella =
                tulvariskialueet.filter(
                  item =>
                    item.etäisyys !== "Alueella"
                );

              return (
                <div
                  key={
                    rakennus.id_rakennus ||
                    rakennus.rakennustunnus ||
                    rakennusIndex
                  }
                >
                  {rakennukset.length > 1 && (
                    <div
                      className="px-3 py-2 fw-bold"
                      style={{
                        backgroundColor:
                          "#e2e2e2"
                      }}
                    >
                      Rakennus:{" "}
                      {getRakennusLabel(
                        rakennus
                      )}
                    </div>
                  )}

                  <table className="table table-sm mb-0">
                    <tbody>
                      {/* TULVARISKISTATUS */}

                      <tr>
                        <th
                          className="px-3 py-2 fw-normal"
                          style={{
                            width: "42%",
                            backgroundColor:
                              LIGHT_GREY,
                            border: 0
                          }}
                        >
                          Sijaitsee
                          tulvariskialueella
                        </th>

                        <td
                          className="px-3 py-2 fw-bold"
                          style={{
                            backgroundColor:
                              LIGHT_GREY,
                            border: 0
                          }}
                        >
                          {alueella.length > 0
                            ? "Kyllä"
                            : "Ei"}
                        </td>
                      </tr>

                      {/* OIKEASTI ALUEELLA */}

                      {alueella.map(
                        (tulvariski, index) => (
                          <>
                            <tr
                              key={`alue-title-${index}`}
                            >
                              <th
                                colSpan={2}
                                className="px-3 py-2"
                                style={{
                                  backgroundColor:
                                    "#fafafa",
                                  border: 0
                                }}
                              >
                                {alueella.length >
                                1
                                  ? `Tulvariskialue ${index + 1}`
                                  : "Tulvariskialue"}
                              </th>
                            </tr>

                            <tr
                              key={`alue-name-${index}`}
                            >
                              <th
                                className="px-3 py-2 fw-normal"
                                style={{
                                  backgroundColor:
                                    WHITE,
                                  border: 0
                                }}
                              >
                                Nimi
                              </th>

                              <td
                                className="px-3 py-2"
                                style={{
                                  backgroundColor:
                                    WHITE,
                                  border: 0
                                }}
                              >
                                {renderValue(
                                  tulvariski.nimi
                                )}
                              </td>
                            </tr>

                            {tulvariski.lähde && (
                              <tr
                                key={`alue-source-${index}`}
                              >
                                <th
                                  className="px-3 py-2 fw-normal"
                                  style={{
                                    backgroundColor:
                                      WHITE,
                                    border: 0
                                  }}
                                >
                                  Tyyppi
                                </th>

                                <td
                                  className="px-3 py-2"
                                  style={{
                                    backgroundColor:
                                      WHITE,
                                    border: 0
                                  }}
                                >
                                  {
                                    tulvariski.lähde
                                  }
                                </td>
                              </tr>
                            )}

                            <tr
                              key={`alue-distance-${index}`}
                            >
                              <th
                                className="px-3 py-2 fw-normal"
                                style={{
                                  backgroundColor:
                                    WHITE,
                                  border: 0
                                }}
                              >
                                Sijainti
                              </th>

                              <td
                                className="px-3 py-2"
                                style={{
                                  backgroundColor:
                                    WHITE,
                                  border: 0
                                }}
                              >
                                Alueella
                              </td>
                            </tr>
                          </>
                        )
                      )}

                      {/* LÄHELLÄ OLEVAT */}

                      {lahella.length > 0 && (
                        <>
                          <tr>
                            <th
                              colSpan={2}
                              className="px-3 py-2"
                              style={{
                                backgroundColor:
                                  LIGHT_GREY,
                                border: 0
                              }}
                            >
                              Lähistöllä olevat
                              tulvariskialueet
                            </th>
                          </tr>

                          {lahella.map(
                            (
                              tulvariski,
                              index
                            ) => (
                              <tr
                                key={`near-${index}`}
                              >
                                <th
                                  className="px-3 py-2 fw-normal"
                                  style={{
                                    width: "42%",
                                    backgroundColor:
                                      WHITE,
                                    border: 0
                                  }}
                                >
                                  {renderValue(
                                    tulvariski.lähde ||
                                      tulvariski.nimi
                                  )}
                                </th>

                                <td
                                  className="px-3 py-2"
                                  style={{
                                    backgroundColor:
                                      WHITE,
                                    border: 0
                                  }}
                                >
                                  {tulvariski.etäisyys
                                    ? `${tulvariski.etäisyys} etäisyydellä`
                                    : "–"}
                                </td>
                              </tr>
                            )
                          )}
                        </>
                      )}

                      {/* EI MITÄÄN 500 M SÄTEELLÄ */}

                      {tulvariskialueet.length ===
                        0 && (
                        <tr>
                          <td
                            colSpan={2}
                            className="px-3 py-2 text-muted"
                            style={{
                              backgroundColor:
                                WHITE,
                              border: 0
                            }}
                          >
                            Tulvariskialueita ei
                            havaittu 500 metrin
                            säteellä.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {rakennusIndex <
                    rakennukset.length - 1 && (
                    <div
                      style={{
                        height: 1,
                        backgroundColor:
                          "#dddddd"
                      }}
                    />
                  )}
                </div>
              );
            }
          )
        )}
      </section>
    </div>
  );
}